import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Fade, type Theme, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { statements } from '@/constants';
import { IconsBox, MainBox } from './Statements.styles';

const TIMEOUT = 1000;

export const Statements = () => {
    const { t } = useTranslation();
    const [activeIndex, setActiveIndex] = useState(0);
    const [show, setShow] = useState(true);

    const getBulletColor = (theme: Theme, index: number) => {
        if (theme.palette.mode === 'dark') {
            return index === activeIndex ? theme.palette.secondary.main : theme.palette.primary.main;
        }
        return index === activeIndex ? theme.palette.secondary.main : theme.palette.secondary.light;
    };

    useEffect(() => {
        const timer = setInterval(() => {
            setShow(false);
            setTimeout(() => {
                setActiveIndex(prevIndex => (prevIndex === statements(t).length - 1 ? 0 : prevIndex + 1));
                setShow(true);
            }, TIMEOUT / 2);
        }, 5000);

        return () => clearInterval(timer);
    }, [t]);

    return (
        <MainBox>
            <Fade in={show} timeout={TIMEOUT}>
                <div className="flex flex-wrap w-full gap-[16px]">
                    <Typography
                        children={statements(t)[activeIndex]?.text}
                        variant="subtitle1"
                        color={theme =>
                            theme.palette.mode === 'dark' ? theme.palette.primary.contrastText : theme.palette.secondary.light
                        }
                    />
                    <Typography
                        variant="subtitle3"
                        children={statements(t)[activeIndex]?.author}
                        color={theme => (theme.palette.mode === 'dark' ? theme.custom.c4 : theme.palette.primary.contrastText)}
                    />
                </div>
            </Fade>
            <IconsBox>
                {statements(t).map((el, index) => (
                    <FiberManualRecordIcon
                        key={el.author}
                        sx={{
                            color: theme => getBulletColor(theme, index),
                            fontSize: index === activeIndex ? '0.5rem' : '0.375rem',
                        }}
                    />
                ))}
            </IconsBox>
        </MainBox>
    );
};
